export default __webpack_public_path__ + "68d29083ccbbf60adbdc0ca44df14b1e.webp";